import {
    isSkunexusUser,
    removeCurrentPassowrdFromFormProps,
    removeCurrentPasswordFormFromFormFields,
    removeCurrentPasswordFormFromFormSections,
} from '../utils';

export default {
    name: 'userProfilePage',
    before: [],
    after: [],
    setup: (app) => {
        const routeName = 'userProfile';
        const route = app.routes.getItem(routeName);
        if (route) {
            const routeProps = route.props;

            route.props = (state) => ({
                ...routeProps(state),
                config: {
                    withPasswordForm: isSkunexusUser(),
                },
                passwordFormProps: {
                    customFormFields: removeCurrentPasswordFormFromFormFields,
                    customFormProps: removeCurrentPassowrdFromFormProps,
                },
                detailsFormProps: {
                    customFormFields: removeCurrentPasswordFormFromFormSections,
                    customFormProps: removeCurrentPassowrdFromFormProps,
                },
            });

            app.routes.changeItem(routeName, route);
        }
    },
};
